export const STATUS_LABELS = {
  pending: "Pending", under_review: "Under review", resolved: "Resolved", dismissed: "Dismissed",
};
export const REASON_LABELS = {
  fraud_scam: "Fraud or scam", misleading_information: "Misleading information",
  inappropriate_content: "Inappropriate content", harassment: "Harassment", other: "Other",
};
export const ACTION_LABELS = {
  remove_listing: "Remove listing", suspend_seller: "Suspend seller",
  remove_listing_and_suspend_seller: "Remove listing and suspend seller", none: "No action",
};
export const isOpen = (report) => ["pending", "under_review"].includes(report?.status);
export const formatDate = (value) => value ? new Date(value).toLocaleString() : "—";
export const deadline = (report, now = Date.now()) => {
  if (!isOpen(report)) return { label: "Review completed", overdue: false };
  const remaining = new Date(report.dueAt).getTime() - now;
  if (!Number.isFinite(remaining)) return { label: "Deadline unavailable", overdue: false };
  const minutes = Math.max(1, Math.ceil(Math.abs(remaining) / 60000));
  const duration = `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
  return { label: remaining <= 0 ? `Overdue by ${duration}` : `${duration} remaining`, overdue: remaining <= 0 };
};
export const canTakeAction = (report, action) => {
  const listingAvailable = Boolean(report?.listing?.id);
  const sellerAvailable = Boolean(report?.reportedUser?.id);
  if (action === "remove_listing") return listingAvailable;
  if (action === "suspend_seller") return sellerAvailable;
  if (action === "remove_listing_and_suspend_seller") return listingAvailable && sellerAvailable;
  return action === "none";
};
